function gtag_report_conversion_pas_confirm_click(url) {
  var callback = function () {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };
  console.log('conversion tracked');

  gtag('event', 'conversion', {
    send_to: 'AW-17689061394/cCRCCNe5mMEbEJLQ5vJB',
    value: 1.0,
    currency: 'CZK',
    event_callback: callback,
  });
  return false;
}

function gtag_report_conversion_car_next_button(url) {
  var callback = function () {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
    send_to: 'AW-17689061394/EgQECJ7jpsEbEJLQ5vJB',
    value: 1.0,
    currency: 'CZK',
    event_callback: callback,
  });
  return false;
}

export {
  gtag_report_conversion_pas_confirm_click,
  gtag_report_conversion_car_next_button,
};


